import { CommonModule } from '@angular/common';
import {
  Component,
  signal,
  output,
  computed,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { StructureOption } from '../../../../models/structure.models';

@Component({
  selector: 'app-structure',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './structure.component.html',
  styleUrl: './structure.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StructureComponent implements OnInit {
  ngOnInit(): void {
    // Emit initial data on component initialization
    this.emitDataChange();
  }
  selectedQuantity = signal<string>('M');
  selectedDuration = signal<string>('L'); // Default to M (3-5 min)

  quantityOptions: StructureOption[] = [
    {
      value: 'S',
      translationKey:
        'app.components.courseCreator.settings.structure.quantityOptions.S',
    },
    {
      value: 'M',
      translationKey:
        'app.components.courseCreator.settings.structure.quantityOptions.M',
    },
    {
      value: 'L',
      translationKey:
        'app.components.courseCreator.settings.structure.quantityOptions.L',
    },
    {
      value: 'XL',
      translationKey:
        'app.components.courseCreator.settings.structure.quantityOptions.XL',
    },
  ];

  durationOptions: StructureOption[] = [
    {
      value: 'S',
      translationKey:
        'app.components.courseCreator.settings.structure.durationOptions.S',
    },
    {
      value: 'M',
      translationKey:
        'app.components.courseCreator.settings.structure.durationOptions.M',
    },
    {
      value: 'L',
      translationKey:
        'app.components.courseCreator.settings.structure.durationOptions.L',
    },
    {
      value: 'XL',
      translationKey:
        'app.components.courseCreator.settings.structure.durationOptions.XL',
    },
  ];

  selectQuantity(value: string): void {
    this.selectedQuantity.set(value);
    this.emitDataChange();
  }

  selectDuration(value: string): void {
    this.selectedDuration.set(value);
    this.emitDataChange();
  }

  // Output to emit data changes to parent
  dataChange = output<{
    quantity: string;
    duration: string;
  }>();

  // Computed value for current data
  private currentData = computed(() => ({
    quantity: this.selectedQuantity(),
    duration: this.selectedDuration(),
  }));

  // Emit data change
  private emitDataChange(): void {
    this.dataChange.emit(this.currentData());
  }
}
